import React from 'react';

import classes from './SearchResultHeaderBox.scss';

const searchResultHeaderBox = (props) => (
    <span className={[
        classes.BackgroundBox,
        props.type === '1' ? classes.BackgroundBoxOne
        : props.type === '2' ? classes.BackgroundBoxTwo
        : props.type === '3' ? classes.BackgroundBoxThree
        : null
    ].join(' ')}
    {...props}>{props.children}</span>
);

export default searchResultHeaderBox;


// WEBPACK FOOTER //
// ./src/components/UI/Headers/SearchResultHeader/SearchResultHeaderBox/SearchResultHeaderBox.js